module.exports = __webpack_public_path__ + "static/media/chart-network.d4e90f8e.svg";